<script>
  // import { Link } from '@inertiajs/svelte'
  import Tooltip from '@components/tooltip.svelte'
  import TriggerChevron from '@components/trigger-chevron.svelte'
  import { Loader2 } from 'lucide-svelte'
  import { cn } from '@lib/utils'

  let {
    text,
    type = "button",
    naked = false,
    disabled: disabledProp = false,
    loading = false,
    Icon,
    BeforeIcon,
    path,
    externalPath,
    iconSize = 13,
    iconClass,
    iconStrokeWidth = 1.5,
    hint,
    children,
    class: className,
    style: styleProps,
    tooltipDelay,
    tooltipClass,
    open,
    ref = $bindable(),
    ...restProps
  } = $props()


  let disabled = $derived(disabledProp || loading)
  let actionable = $derived(path || restProps.onclick)

  let classes = $derived(cn(
    "flex items-center gap-2",
    naked ? "" : "button",
    disabled ? "cursor-not-allowed opacity-60" : "",
    actionable && !disabled ? "cursor-pointer" : "",
    loading ? "loading" : "",
    className,
  ))

  let attributes = $derived({ class: classes, type, ...restProps })

  let style = $derived.by(() => {
    if (!styleProps) return null
    if (typeof styleProps === "string") return styleProps
    return Object.entries(styleProps).map(([key, value]) => `${key}: ${value}`).join(";")
  })

</script>

{#snippet contents()}
  {#if BeforeIcon}
    <BeforeIcon size={iconSize} strokeWidth={iconStrokeWidth} />
  {/if}
  {text}
  {#if loading}
    <Loader2 size={iconSize} strokeWidth={iconStrokeWidth} class="animate-spin" />
  {:else if Icon}
    <Icon size={iconSize} strokeWidth={iconStrokeWidth} class={iconClass} />
  {:else if (![null, undefined].includes(open))}
    <TriggerChevron {open} />
  {/if}
{/snippet}

{#snippet inner()}
  {#if children}
    {@render children()}
  {:else}
    {@render contents()}
  {/if}
{/snippet}

<Tooltip {hint} delay={tooltipDelay} class={tooltipClass}>
  {#if externalPath}
    <a bind:this={ref} href={externalPath} {style} {...attributes}>
      {@render inner()}
    </a>
  {:else if path}
    <a bind:this={ref} href={path} {style} {...attributes}>
      {@render inner()}
    </a>
  {:else}
    <button bind:this={ref} {style} {disabled} {...attributes}>
      {@render inner()}
    </button>
  {/if}
</Tooltip>
